"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduce = _interopRequireDefault(require("lodash/reduce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const rejectUndefined = subject => (0, _reduce.default)(subject, (acc, value, key) => {
  if (subject[key] !== undefined) {
    acc[key] = value;
  }

  return acc;
}, {});

var _default = rejectUndefined;
exports.default = _default;